import styled from '@emotion/styled';
import { PopoverPanel } from '@headlessui/react';

import { LocalizedLink } from '../../../../../LocalizedLink/LocalizedLink';

export const StyledPanel = styled(PopoverPanel)`
  position: relative;
  background: var(--color-white);
  padding: var(--spacing-8);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  box-shadow: var(--elevation-20);
  border-radius: var(--border-radius-l);
  z-index: 10;
  transition:
    opacity 0.2s,
    transform 0.2s ease-in-out;
  --anchor-gap: var(--spacing-24);

  &[data-closed] {
    transform: translateY(calc(var(--spacing-8) * -1));
    opacity: 0;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-4);
  grid-auto-flow: row;
`;

export const Separator = styled.div`
  background: var(--color-neutral-30);
  width: 100%;
  height: 1px;
  flex: 1px 0 0;
`;

export const StyledLink = styled(LocalizedLink)`
  padding: var(--spacing-12);
  font: var(--font-body-m-light);
  color: var(--color-black);
  white-space: nowrap;
  border-radius: var(--border-radius-m);
  text-decoration: none;
  transition: background 0.3s;

  &:hover,
  &:focus-visible {
    background-color: var(--color-neutral-20);
  }
`;
